import React, { useState } from 'react';
import Accordion from 'semantic-ui-react/dist/commonjs/modules/Accordion';
import { Grid, Icon } from 'semantic-ui-react';
import { FieldArray } from 'react-final-form-arrays';
import CodeGroupsSegment from 'components/segments/CodeGroupsSegment';
import { MessageSourceProps, withMessages } from 'react-message-source';
import styled from 'styled-components';
import { MutableState, Tools } from 'final-form';
import { CodeDto, TreatmentCodeDto } from 'ts-types/api.types';

const StyledSpecialElementBorder = styled(Grid)`
     border-bottom: 1px solid rgba(34,36,38,.1);
     padding-top: 0 !important;
`;


interface Props extends MessageSourceProps {
  addToTreatmentCodes: (code: CodeDto) => void,
  addAllToTreatmentCodes: (codes: Array<CodeDto>) => void,
  removeTreatmentCode: (args: any, state: MutableState, utils: Tools) => Array<TreatmentCodeDto>,
  removeAllTreatmentCodes: (args: any, state: MutableState, utils: Tools) => Array<TreatmentCodeDto>,
  readOnly: boolean
}

const TreatmentCodesAccordion: React.FC<Props> = (props: Props) => {

  const { addToTreatmentCodes, addAllToTreatmentCodes, removeTreatmentCode,
    removeAllTreatmentCodes, getMessage, readOnly } = props;
  const [active, toggleAccordion] = useState(false);

  return (
      <StyledSpecialElementBorder>
        <Accordion fluid>
          <Accordion.Title active={active} onClick={() => toggleAccordion(!active)}>
            <h4><Icon name='dropdown'/>{getMessage('treatment.generate.codes')}</h4>
          </Accordion.Title>
          <Accordion.Content active={active}>
            <Grid.Row>
              <Grid.Column>
                <FieldArray name="treatmentCodes">
                  {({ fields }) =>
                      <CodeGroupsSegment
                          selectedCodes={fields.value}
                          moveToSelected={addToTreatmentCodes}
                          moveAllToSelected={addAllToTreatmentCodes}
                          removeFromSelected={removeTreatmentCode}
                          removeAllFromSelected={removeAllTreatmentCodes}
                          readOnly={readOnly}
                      />
                  }
                </FieldArray>
              </Grid.Column>
            </Grid.Row>
          </Accordion.Content>
        </Accordion>
      </StyledSpecialElementBorder>
  )
};

export default withMessages(TreatmentCodesAccordion);
